<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Paramètres"
                createIconText="Ajouter un paramètre"
                importDatasourceName="params"
                (created)="onParamsCreated()"
                (exported)="onParamsExported()"
                (imported)="onParamsImported()"
                (helped)="onParamsHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-parameters-list
            #itemsList
            (itemSelected)="onParamsSelected($event)"
            (itemDisplayed)="onParamsDisplayed($event)"
            (itemEdited)="onParamsEdited($event)"
            (itemDeleted)="onParamsDeleted($event)"
            (itemDuplicated)="onParamsDuplicated($event)"></app-parameters-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onParamsDisplayed(context?.formContext.item)"
                    (edited)="onParamsEdited(context?.formContext.item)"
                    (helped)="onParamsHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-parameters-detail [context]="context" (paramsUpdated)="onParamsUpdated($event)" (canceled)="onBackToList()"></app-parameters-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
